export default __webpack_public_path__ + "static/media/SmartDrill.c8242a886043f226677ca28799fab3ea.webp";